import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=6243b7ce&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6243b7ce')) {
      api.createRecord('6243b7ce', component.options)
    } else {
      api.reload('6243b7ce', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=6243b7ce&", function () {
      api.rerender('6243b7ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/viewKnowledge/settings/Settings.vue"
export default component.exports